import React from "react";
import Error from "../error/error"
import analytics from "../../shared/analytics"

const team = props => {
  let cardContent = props.team.team.map(person => {

    let disableTel = "disabled"
    let disableEmail = "disabled"

    const TelButtonClickHandler = () => {
      logTelephone();
      window.location.href = `tel:${person.telephone}`
    }

    const EmailButtonClickHandler = () => {
      logEmail();
      window.location.href = `mailto:${person.mailId}`
    }

    let PersonDetails = (
      <p>
        <strong>{person.personName}</strong><br />
        <span>{person.roleType}</span>
      </p>
    )

    let Telephone = null
    if (person.telephone !== null && person.telephone !== '') {
      disableTel = null
      Telephone = (
        <p>
          <span>Tel: </span>
          <a href={`tel:${person.telephone}`} onClick={logTelephone}>{person.telephone}</a>
        </p>
      )
    }

    let Email = null
    if (person.mailId !== null && person.mailId !== '') {
      disableEmail = null
      Email = (
        <p>
          <span>Email: </span>
          <a href={`mailto:${person.mailId}`} onClick={logEmail}>{person.mailId}</a>
        </p>
      )
    }

    let Url = null
    if (person.url !== null && person.url !== '') {
      let urlRef = person.url;
      if (!urlRef.startsWith("http://") && !urlRef.startsWith("https://")) {
        urlRef = "http://" + urlRef;
      }
      Url = (
        <p>
          <span>URL: </span>
          <a target="_blank" rel="noopener noreferrer" href={urlRef} onClick={logUrl}>{person.url}</a>
        </p>
      )
    }

    return (
      <mosaic-contact-details key={person.personUid}>
        <mosaic-contact-details-info>
          {PersonDetails}
          <div className="mt-2">
            {Telephone}
            {Email}
            {Url}
          </div>
        </mosaic-contact-details-info>
        <mosaic-button icon="phone" color="light" disabled={disableTel} onClick={TelButtonClickHandler}></mosaic-button>
        <mosaic-button icon="email" color="light" disabled={disableEmail} onClick={EmailButtonClickHandler}></mosaic-button>
      </mosaic-contact-details>
    );
  });

  let emptyCard = <p>There are no contacts to display.</p>;
  if (cardContent.length < 1) {
    cardContent = emptyCard;
  }

  if (props.team.error) cardContent = Error(props.team.error);

  return (
    <mosaic-col xl="6">
      <mosaic-card id={props.cardName} fixed-height full-height>
        <mosaic-card-header title="Team" />
        <mosaic-card-body>
          <div>{cardContent}</div>
        </mosaic-card-body>
      </mosaic-card>
    </mosaic-col>
  );
};

const logEmail = () => {
  logContact("Email");
};

const logTelephone = () => {
  logContact("Telephone");
};

const logUrl = () => {
  logContact("Url");
};

function logContact(type) {
  analytics.trackEvent({
    "key": "Contact.Customer",
    "segmentation": {
      "Type": type
    }
  });
};

export default team;


